import React from "react";
import Navbar from "../Components/Navbar";
import FamilyCampPage1 from "../Components/FamilyCampPage1";
import FamilyCampPage2 from "../Components/FamilyCampPage2";
import FamilyCampPage3 from "../Components/FamilyCampPage3";
import '../Styles/CampsFamily.scss';
import {Helmet} from "react-helmet";
import Footer from "../Components/Footer.js";

function CampsFamily() {
   return (
      <div>
        <Helmet>
            <title>Family Camp - Camp Connect</title>
         </Helmet>
        <div className='familyNavbar'>
            <Navbar />
         </div>
         <FamilyCampPage1/>
         <FamilyCampPage2/>
         <FamilyCampPage3/>
         <Footer/>
      </div>
   )
};

export default CampsFamily;
